'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkNetworkOnTimeout = undefined;

var _checkNetwork = require('../clients/checkNetwork');

var _buildError = require('conversations-error-reporting/error-reporting/builders/buildError');

var ERROR_CODES = ['TIMEOUT', 'NETWORKERROR'];

var checkNetworkOnTimeout = exports.checkNetworkOnTimeout = function checkNetworkOnTimeout(fn) {
  var networkAvailable = true;

  var handleApiSuccess = function handleApiSuccess(data) {
    networkAvailable = true;
    return data;
  };

  var handleApiFailure = function handleApiFailure(error) {
    if (error instanceof Error && error.status === 0 && ERROR_CODES.includes(error.errorCode)) {
      if (!networkAvailable) throw (0, _buildError.buildError)('Network Unavailable', error);

      return (0, _checkNetwork.checkNetwork)().then(function (_ref) {
        var online = _ref.online;

        if (online) throw error;
        networkAvailable = false;
        throw (0, _buildError.buildError)('Network Unavailable', error);
      });
    }

    networkAvailable = true;
    throw error;
  };

  return function () {
    return fn.apply(undefined, arguments).then(handleApiSuccess, handleApiFailure);
  };
};